import { Component } from '@cms-max/medicare-api-sdk'
import { useMemo } from 'react'
import { CoreUnderivedEventData } from '../core'
import { TealiumUnderivedEventData } from '../tealium'
import { useEvent, UseEventConfig, UseEventConfigGeneric } from './useEvent'

export type UseChatEventConfig = UseEventConfigGeneric<Omit<CoreUnderivedEventData, 'property' | 'component'>, TealiumUnderivedEventData>

/**
 *
 * @param options
 * @returns an event with the core property defaulted to MAX and core component defaulted to Header
 */
export const useChatEvent = (options: UseChatEventConfig) => {
  const eventFactoryConfig = useMemo(() => {
    const config: UseEventConfig = {}
    if (options.core) {
      config.core = {
        property: 'MAX',
        component: Component.LiveChat,
        ...options.core
      }
    }
    if (options.tealium) {
      config.tealium = options.tealium
    }

    return config
  }, [options])

  const createEvent = useEvent(eventFactoryConfig)
  return createEvent
}
